// extracted by mini-css-extract-plugin
module.exports = {"no-files-text":"NoFilesDisplay_no-files-text__m7jgd"};